module.exports = __webpack_public_path__ + "static/media/logo.1616598b.png";